import { batchActions } from 'redux-batched-actions';
import { each } from 'lodash';

import settings from '../settings';

import { MOD_STATE } from '../utils/constants';
import { fetchWithSpinner, fetchWrapper as fetch } from '../utils/fetch';
import {
    processModEditComments,
    processModEditDetailsData,
    processModEditVersionAdd,
    processUpdateModVersions,
    processUpdModVersions,
} from '../utils/responseProcessing';
import { pushHistoryWithAdminSection, pushHistoryWithModderSection } from '../utils/routing';
import urls from '../apiUrls';

import { updateChangelogHistoryItems } from '../actions/ChangelogHistory';
import { openDialogError } from '../actions/DialogError';
import { setIsForbidden } from './SectionModder';
import { getUsername, getUserRole } from '../utils/functions';
import { SET_ERROR_FETCHING_ADMIN_PANEL, setErrorFetchingAdmin, stopFetchingAdminPanel, UPDATE_ITEMS_ADMIN_PANEL, updateItemsAdminPanel } from './AdminPanel';
import { openDialog } from './Dialog';

export const showDialogError = () => {
    return (dispatch) => {
        dispatch(openDialogError())
    }
}

export const ADD_MOD_VERSION_COMPLETED = 'ADD_MOD_VERSION_COMPLETED'
export const CHANGE_MOD_VERSION_VISIBILITY_COMPLETED = 'CHANGE_MOD_VERSION_VISIBILITY_COMPLETED'
export const REMOVE_MOD_VERSION_COMPLETED = 'REMOVE_MOD_VERSION_COMPLETED'
export const UPDATE_MOD_VERSION_COMPLETED = 'UPDATE_MOD_VERSION_COMPLETED'
export const SET_ERROR_FETCHING_EDIT_COMMENTS = 'SET_ERROR_FETCHING_EDIT_COMMENTS'
export const SET_ERROR_FETCHING_EDIT_DETAILS = 'SET_ERROR_FETCHING_EDIT_DETAILS'
export const SET_MOD_VERSION_UPLOAD_FROM_VISIBILITY = 'SET_MOD_VERSION_UPLOAD_FROM_VISIBILITY'
export const START_FETCHING_EDIT_COMMENTS = 'START_FETCHING_EDIT_COMMENTS'
export const START_FETCHING_EDIT_DETAILS = 'START_FETCHING_EDIT_DETAILS'
export const STOP_FETCHING_EDIT_COMMENTS = 'STOP_FETCHING_EDIT_COMMENTS'
export const STOP_FETCHING_EDIT_DETAILS = 'STOP_FETCHING_EDIT_DETAILS'
export const UPDATE_EDIT_COMMENTS = 'UPDATE_EDIT_COMMENTS'
export const UPDATE_EDIT_DETAILS = 'UPDATE_EDIT_DETAILS'
export const UPDATE_EDIT_MOD_STATE = 'UPDATE_EDIT_MOD_STATE'
export const UPDATE_VERSION_MOD_STATUS = 'UPDATE_VERSION_MOD_STATUS'
export const UPDATE_EDIT_MOD_VISIBILITY = 'UPDATE_EDIT_MOD_VISIBILITY'

export const startFetchingEditDetails = () => ({
    type: START_FETCHING_EDIT_DETAILS,
})

export const startFetchingEditComments = () => ({
    type: START_FETCHING_EDIT_COMMENTS,
})

export const stopFetchingEditDetails = () => ({
    type: STOP_FETCHING_EDIT_DETAILS,
})

export const stopFetchingEditComments = () => ({
    type: STOP_FETCHING_EDIT_COMMENTS,
})

export const updateEditDetails = (rawResponseData, state) => ({
    type: UPDATE_EDIT_DETAILS,
    payload: {
        data: processModEditDetailsData(rawResponseData, state),
        id: rawResponseData.id,
    },
})

export const updateEditComments = (rawResponseData) => ({
    type: UPDATE_EDIT_COMMENTS,
    payload: {
        comments: processModEditComments(rawResponseData),
    },
})

export const updateEditModState = (modState) => ({
    type: UPDATE_EDIT_MOD_STATE,
    payload: {
        modState,
    },
})

export const updateVersionModStatus = (rawResponseData) => ({
    type: UPDATE_VERSION_MOD_STATUS,
    payload: processUpdateModVersions(rawResponseData),
})

export const updateEditModVisibility = (isHidden) => ({
    type: UPDATE_EDIT_MOD_VISIBILITY,
    payload: {
        isHidden,
    },
})

export const setErrorFetchingEditDetails = (errorData) => ({
    type: SET_ERROR_FETCHING_EDIT_DETAILS,
    payload: {
        errorData,
    },
})

export const setErrorFetchingEditComments = (errorData) => ({
    type: SET_ERROR_FETCHING_EDIT_COMMENTS,
    payload: {
        errorData,
    },
})

export const removeModVersionCompleted = (modVersionId) => ({
    type: REMOVE_MOD_VERSION_COMPLETED,
    payload: {
        modVersionId,
    },
})

export const changeModVersionVisibilityCompleted = (rawResponseData) => ({
    type: CHANGE_MOD_VERSION_VISIBILITY_COMPLETED,
    payload: {
        modVersionId: rawResponseData.id,
        isVisible: rawResponseData.is_visible,
    },
})

export const addModVersionCompleted = (rawResponseData) => ({
    type: ADD_MOD_VERSION_COMPLETED,
    payload: {
        version: processModEditVersionAdd(rawResponseData),
    },
})

export const setModVersionUploadFormVisibility = (isVisible) => ({
    type: SET_MOD_VERSION_UPLOAD_FROM_VISIBILITY,
    payload: {
        isVisible,
    },
})

export const fetchEditDetails = (modId, ownerId, role) => {
    return (dispatch, getState) => {
        const state = getState()
        const url = `https://tankimods.net`+urls.modsOwner+`?mod_id=${modId}&owner_id=${ownerId}&role=${role}`
        // `https://tankimods.net${urls.modsOwnerDetails.replace(/:(modId)/g, modId)}` //

        dispatch(startFetchingEditDetails())

        const fetchPromise = fetch(url, {method: 'POST', body: {modId, ownerId, role}}).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorFetchingEditDetails(rawResponseData.context),
                        stopFetchingEditDetails(),
                    ], SET_ERROR_FETCHING_EDIT_DETAILS))
                } else {
                    dispatch(batchActions([
                        updateEditDetails(rawResponseData, state),
                        updateChangelogHistoryItems(rawResponseData),
                        stopFetchingEditDetails(),
                    ], UPDATE_EDIT_DETAILS))
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorFetchingEditDetails(errorData),
                    stopFetchingEditDetails(),
                ], SET_ERROR_FETCHING_EDIT_DETAILS))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const fetchEditComments = (modId, code) => {
    return (dispatch) => {
        const url = `https://tankimods.net${urls.modComments}?mod_id=${modId}&type=${code}`
        //`https://tankimods.net${urls.modComments}?mod_id=${modId}&code=${code}` //`${urls.modComments}?mod_id=${mod_id}`

        dispatch(startFetchingEditComments())

        const fetchPromise = fetch(url, {method: 'POST', body: {modId, code}}).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorFetchingEditComments(rawResponseData.context),
                        stopFetchingEditComments(),
                    ], SET_ERROR_FETCHING_EDIT_COMMENTS))
                } else {
                    dispatch(batchActions([
                        updateEditComments(rawResponseData),
                        stopFetchingEditComments(),
                    ], UPDATE_EDIT_COMMENTS))
                }
            }, (errorData) => {
                dispatch(batchActions([
                    setErrorFetchingEditComments(errorData),
                    stopFetchingEditComments(),
                ], SET_ERROR_FETCHING_EDIT_COMMENTS))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const changeModVisibility = (modId, isVisible) => {
    return (dispatch) => {
        const url = `https://tankimods.net`+urls.mods+`?modId=${modId}`
        //const url = urls.modDetails.replace(/:(modId)/g, modId) //- /api/mods/:modId/
        const body = {
            is_hidden: !isVisible,
        }
        const headers = {
            'X-API-Version': '2',
        }

        const fetchPromise = fetch(url, { method: 'PATCH', body, headers }).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(showDialogError())
                } else {
                    dispatch(updateEditModVisibility(rawResponseData.is_hidden))
                }
            }, () => {
                dispatch(showDialogError())
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const changeModStatus = (modId, status) => {
    return (dispatch) => {
        const url = `https://tankimods.net`+urls.mods+`?modId=${modId}`
        //const url = urls.modDetails.replace(/:(modId)/g, modId)

        const body = {
            status,
        }
        const headers = {
            'X-API-Version': '2',
        }

        const fetchPromise = fetch(url, { method: 'PATCH', body, headers }).promise
            .then((rawResponseData) => {
                dispatch(updateEditModState(rawResponseData.state))
            }, () => {
                dispatch(showDialogError())
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const removeModVersion = (modVersionId) => {
    return (dispatch) => {
        const url = `https://tankimods.net${urls.modVersionDetails}${modVersionId}` // urls.modVersionDetails.replace(/:(modVersionId)/g, modVersionId)

        const fetchPromise = fetch(url, { method: 'DELETE' }).promise
            .then((rawResponseData) => {
                dispatch(batchActions([
                    removeModVersionCompleted(rawResponseData.id),
                    updateEditModState(rawResponseData.mod_state),
                ], REMOVE_MOD_VERSION_COMPLETED))
            }, () => {
                dispatch(showDialogError())
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const rejectModVersion = (modVersionId, text, author, authorId, authorRole, type) => { // type - modId from ModderItem in ModareatorPanel
    return (dispatch, getState) => {
        const state = getState()
        var fetchPromise

        if (type) {
            const url = `https://tankimods.net${urls.modVersionDetails}${modVersionId}&modReject=true&text=${text}&author=${author}&author_id=${authorId}&author_role=${authorRole}` 
        
            fetchPromise = fetch(url, { method: 'DELETE' }).promise
                .then((rawResponseData) => {
                    if (rawResponseData.status === 'error') {
                        dispatch(batchActions([
                            setErrorFetchingAdmin(rawResponseData.context),
                            stopFetchingAdminPanel(),
                        ], SET_ERROR_FETCHING_ADMIN_PANEL))
                    } else {
                        dispatch(batchActions([
                            updateItemsAdminPanel(rawResponseData.body, state),
                            stopFetchingAdminPanel(),
                        ], UPDATE_ITEMS_ADMIN_PANEL))
                    }
                    /*dispatch(batchActions([
                        updateVersionModStatus(rawResponseData),
                        updateEditModState(rawResponseData.mod_state),
                    ], UPDATE_MOD_VERSION_COMPLETED))*/
                }, (error) => {
                    dispatch(batchActions([
                        setErrorFetchingAdmin(error.context),
                        stopFetchingAdminPanel(),
                        showDialogError(),
                    ], SET_ERROR_FETCHING_ADMIN_PANEL))
                    //dispatch(showDialogError())
                })
        } else {
            const url = `https://tankimods.net${urls.modVersionDetails}${modVersionId}&reject=true&text=${text}&author=${author}&author_id=${authorId}&author_role=${authorRole}` // urls.modVersionDetails.replace(/:(modVersionId)/g, modVersionId)
        
            fetchPromise = fetch(url, { method: 'DELETE' }).promise
                .then((rawResponseData) => {
                    dispatch(batchActions([
                        updateVersionModStatus(rawResponseData),
                        updateEditModState(rawResponseData.mod_state),
                    ], UPDATE_MOD_VERSION_COMPLETED))
                }, (error) => {
                    dispatch(showDialogError())
                })
        }
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const publishModVersion = (modVersionId, type) => { // type - modId from ModderItem in ModareatorPanel
    return (dispatch, getState) => {
        const state = getState()
        var fetchPromise

        if (type) {
            const url = `https://tankimods.net${urls.modVersionDetails}${modVersionId}&modPublish=true` // modVersionId = modId

            fetchPromise = fetch(url, { method: 'DELETE' }).promise
                .then((rawResponseData) => {
                    if (rawResponseData.status === 'error') {
                        dispatch(batchActions([
                            setErrorFetchingAdmin(rawResponseData.context),
                            stopFetchingAdminPanel(),
                        ], SET_ERROR_FETCHING_ADMIN_PANEL))
                    } else {
                        dispatch(batchActions([
                            updateItemsAdminPanel(rawResponseData.body, state),
                            stopFetchingAdminPanel(),
                        ], UPDATE_ITEMS_ADMIN_PANEL))
                    }
                    /*dispatch(batchActions([
                        updateVersionModStatus(rawResponseData),
                        updateEditModState(rawResponseData.mod_state),
                    ], UPDATE_MOD_VERSION_COMPLETED))*/
                }, (error) => {
                    dispatch(batchActions([
                        setErrorFetchingAdmin(error.context),
                        stopFetchingAdminPanel(),
                        showDialogError(),
                    ], SET_ERROR_FETCHING_ADMIN_PANEL))
                    //dispatch(showDialogError())
                })
        } else {
            const url = `https://tankimods.net${urls.modVersionDetails}${modVersionId}&publish=true` // urls.modVersionDetails.replace(/:(modVersionId)/g, modVersionId)

            fetchPromise = fetch(url, { method: 'DELETE' }).promise
                .then((rawResponseData) => {
                    dispatch(batchActions([
                        updateVersionModStatus(rawResponseData),
                        updateEditModState(rawResponseData.mod_state),
                    ], UPDATE_MOD_VERSION_COMPLETED))
                }, (error) => {
                    dispatch(showDialogError())
                })
        }

        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const changeModVersionVisibility = (modVersionId, isVisible) => {
    return (dispatch) => {
        //const url = urls.modVersionDetails.replace(/:(modVersionId)/g, modVersionId)
        const url = `https://tankimods.net${urls.modVersionDetails}${modVersionId}` // urls.modVersionDetails.replace(/:(modVersionId)/g, modVersionId)

        const body = { is_visible: isVisible }
        
        const fetchPromise = fetch(url, { method: 'PATCH', body }).promise
            .then((rawResponseData) => {
                dispatch(batchActions([
                    changeModVersionVisibilityCompleted(rawResponseData),
                ], CHANGE_MOD_VERSION_VISIBILITY_COMPLETED))
            }, () => {
                dispatch(showDialogError())
            })
        return fetchPromise
    }
}

const prepareModVersionBody = (data) => {
    const result = {
        mod: data.modId,
        game_version: data.gameVersionId,
        version: data.modVersion,
        is_visible: data.isPublished,
        temporary_version_file: data.modFileId,
        temporary_version_file_access_token: data.modFileToken,
    }

    if (data.changelog) {
        result.change_log = data.changelog
    }

    if (data.comment) {
        result.comment = data.comment
        //result.user_name = getUsername().spaUsername
    }
    result.user_name = getUsername().spaUsername
    result.user_id = getUsername().spaId
    result.user_role = getUserRole()

    return result
}

export const addModVersion = (modId, data) => {
    return (dispatch) => {
        const url = `https://tankimods.net${urls.modVersionList}/` // urls.modVersionList
        const body = prepareModVersionBody(data)
        const fetchPromise = fetch(url, { method: 'POST', body }).promise
            .then((rawResponseData) => {
                dispatch(batchActions([
                    addModVersionCompleted(rawResponseData),
                    updateEditModState(rawResponseData.mod_state),
                    fetchEditComments(modId, 1),
                ], ADD_MOD_VERSION_COMPLETED))
                //dispatch(fetchEditComments(modId))
            }, () => {
                dispatch(showDialogError())
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

const prepareLocalizationsData = (data) => {
    const result = []

    each(data.byLanguages, (item, language) => {
        if (!item.title) {
            return
        }

        result.push({
            lang: settings.portalLanguages.find((item) => item.code === language).id,
            title: item.title,
            description: item.description,
            installation_guide: item.installationGuide,
        })
    })
    
    return result
}

const prepareChangelogData = (data, state) => {
    let result = []

    if (data.modVersion && data.changelog) {
        result = [
            {
                position: data.position,
                id: data.id, // было id я назвал как позиция
                body: data.changelog,
                //date: '',
                version: data.modVersion,
            },
        ]
    }

    each(state.changelogHistory.items, (historyItem) => {
        result.push({
            position: historyItem.position,
            id: historyItem.id, // было id я назвал как позиция
            body: historyItem.content,
            //date: '',
            version: historyItem.version,
        })
    })

    return result
}

const prepareScreenshotsData = (data) => {
    const result = []
    each(data.screenshots, (item, index) => {
        if (item.accessToken) {
            if (item.source) {
                result.push({
                    access_token: item.accessToken,
                    position: index,
                    temporary_file: item.fileId,
                    source: item.source,
                })
            } else {
                result.push({
                    access_token: item.accessToken,
                    position: index,
                    temporary_file: item.fileId,
                })
            }
        } else {
            result.push({
                screenshot: item.screenshotId,
                source: item.source,
                position: index,
            })
        }
    })

    return result
}

const prepareVoiceoversData = (data) => {
    const result = []
    each(data.voiceovers, (item, index) => {
        if (item.accessToken) {
            result.push({
                access_token: item.accessToken,
                position: index,
                source: item.source,
                temporary_file: item.fileId,
                title: item.sourceOriginalName,
            })
        } else {
            result.push({
                voiceover: item.voiceoverId,
                source: item.source,
                position: index,
                title: item.sourceOriginalName,
            })
        }
    })
    
    return result
}

const prepareModVersionsData = (data, state) => {
    const result = []

    if ([MOD_STATE.DRAFT, MOD_STATE.REJECTED].includes(state.editMod.data.state)) {
        const modVersion = {
            //comment: data.comment,
            game_version: data.gameVersionId,
            id: data.modVersionId,
            version: data.modVersion,
        }
        if (data.modFileId && data.modFileToken) {
            modVersion.temporary_version_file = data.modFileId
            modVersion.temporary_version_file_access_token = data.modFileToken
        }
        if (data.deleteFile) {
            modVersion.delete_file = data.deleteFile
        }
        result.push(modVersion)
    }

    return result
}

export const prepareBody = (modId, data, state, msg) => {
    const body = {
        status: data.status,
        tags: data.categories,
    }

    if (data.coverFileId && data.coverFileToken) {
        body.temporary_cover_file = data.coverFileId
        body.temporary_cover_file_access_token = data.coverFileToken
    } else if (state.editMod.data.cover && !data.coverOriginalSource) {
        body.is_original_cover_removed = true
    }
    
    body.mod_id = modId || null // я добавил
    body.author_name = data.authorName || null
    body.change_log = prepareChangelogData(data, state)
    body.screenshots = prepareScreenshotsData(data)
    body.voiceovers = prepareVoiceoversData(data)
    body.localizations = prepareLocalizationsData(data)
    body.versions = prepareModVersionsData(data, state)

    body.modVersion = data.modVersion || ""
    body.comment = data.comment || null
    body.username = state.currentAccount.spaUsername
    body.user_id = state.currentAccount.spaId

    if (msg) {
        body.msg = msg;
    }
    
    return body
}

export const saveMod = (modId, data, history) => {
    return (dispatch, getState) => {
        const state = getState()
        const body = prepareBody(modId, data, state)
        
        const url = `https://tankimods.net`+urls.mods+`?modId=${modId}`
        //const url = urls.modDetails.replace(/:(modId)/g, modId)
        
        const headers = {
            'X-API-Version': '2',
        }
        
        const fetchPromise = fetch(url, { method: 'PUT', body, headers }).promise
            .then((raw) => {
                pushHistoryWithModderSection(history)
            }, (error) => {
                if (error.status === 403) {
                    Promise.resolve(
                        dispatch(setIsForbidden())
                    ).then(() => {
                        pushHistoryWithModderSection(history)
                    })
                } else {
                    dispatch(showDialogError())
                }
                // eslint-disable-next-line no-console
                console.log('Something went wrong!')
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const publishMod = (modId, data, history) => {
    return (dispatch, getState) => {
        const state = getState()
        const body = prepareBody(modId, data, state)
        
        const url = `https://tankimods.net`+urls.mods+`?review=true&publish=true&modId=${modId}`
        //const url = urls.modDetails.replace(/:(modId)/g, modId)
        
        const headers = {
            'X-API-Version': '2',
        }
        
        const fetchPromise = fetch(url, { method: 'PUT', body, headers }).promise
            .then((raw) => {
                pushHistoryWithAdminSection(history, 'mods')
            }, (error) => {
                if (error.status === 403) {
                    Promise.resolve(
                        dispatch(setIsForbidden())
                    ).then(() => {
                        pushHistoryWithAdminSection(history, 'mods')
                    })
                } else {
                    dispatch(showDialogError())
                }
                // eslint-disable-next-line no-console
                console.log('Something went wrong!')
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const rejectMod = (modId, data, msg, history) => {
    return (dispatch, getState) => {
        const state = getState()
        const body = prepareBody(modId, data, state, msg)
        
        const url = `https://tankimods.net`+urls.mods+`?review=true&reject=true&modId=${modId}`
        //const url = urls.modDetails.replace(/:(modId)/g, modId)
        
        const headers = {
            'X-API-Version': '2',
        }
        
        const fetchPromise = fetch(url, { method: 'PUT', body, headers }).promise
            .then((raw) => {
                pushHistoryWithAdminSection(history, 'mods')
            }, (error) => {
                if (error.status === 403) {
                    Promise.resolve(
                        dispatch(setIsForbidden())
                    ).then(() => {
                        pushHistoryWithAdminSection(history, 'mods')
                    })
                } else {
                    dispatch(showDialogError())
                }
                // eslint-disable-next-line no-console
                console.log('Something went wrong!')
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const removeMod = (modId, history, review) => {
    return (dispatch) => {
        let url
        if (review) {
            url = `https://tankimods.net${urls.mods}?review=true&delete=true&modId=${modId}`
        } else {
            url = `https://tankimods.net${urls.mods}?delete=true&modId=${modId}`
        }
        //const url = urls.modDetails.replace(/:(modId)/g, modId)

        const fetchPromise = fetch(url, { method: 'DELETE' }).promise
            .then((response) => {
                pushHistoryWithModderSection(history)
            }, (error) => {
                dispatch(showDialogError())
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}


export const MOD_VERSIONS_UPDATED = 'MOD_VERSIONS_UPDATED'
export const UPDATE_MOD_VERSIONS = 'UPDATE_MOD_VERSIONS'

export const updateModVersions = (rawResponseData) => ({
    type: UPDATE_MOD_VERSIONS,
    payload: processUpdModVersions(rawResponseData.versions),
})

export const changeGameVersionMod = ({modId, modVersionId, gameVersionId, gameVersion}) => {
    return (dispatch) => {
        const url = `https://tankimods.net${urls.mods}?admin_edit_mod=true&modId=${modId}&modVersionId=${modVersionId}&newGameVersionId=${gameVersionId}&newGameVersion=${gameVersion}`

        const fetchPromise = fetch(url, { method: 'PUT' }).promise // POST
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(showDialogError(rawResponseData.context.msg))
                } else {
                    dispatch(batchActions([
                        updateModVersions(rawResponseData),
                        dispatch(openDialog('Данные версии мода обновлены!'))
                    ], MOD_VERSIONS_UPDATED))
                }
            }, (error) => {
                dispatch(showDialogError())
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const addComment = (modId, content, code) => {
    return (dispatch) => {
        const url = `https://tankimods.net${urls.modComments}`
        const body = {
            mod_id: modId,
            text: content,
            type: code,
            author: getUsername().spaUsername,
            author_id: getUsername().spaId,
            role: getUserRole(),
        }
        
        const fetchPromise = fetch(url, { method: 'PUT', body }).promise // POST
            .then(() => {
                dispatch(fetchEditComments(modId, code))
            }, (error) => {
                dispatch(showDialogError())
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}



export const showComment = (commentId, modId, type) => {
    return (dispatch) => {
        const url = `https://tankimods.net${urls.commentDetails}${commentId}&hide=false` // urls.commentDetails.replace(/:(modVersionId)/g, modVersionId)

        const fetchPromise = fetch(url, { method: 'DELETE' }).promise
            .then((rawResponseData) => {
                dispatch(fetchEditComments(modId, type))
            }, () => {
                dispatch(showDialogError())
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const hideComment = (commentId, modId, type) => {
    return (dispatch) => {
        const url = `https://tankimods.net${urls.commentDetails}${commentId}&hide=true` // urls.commentDetails.replace(/:(modVersionId)/g, modVersionId)

        const fetchPromise = fetch(url, { method: 'DELETE' }).promise
            .then((rawResponseData) => {
                dispatch(fetchEditComments(modId, type))
            }, () => {
                dispatch(showDialogError())
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

export const deleteComment = (commentId, modId, type) => {
    return (dispatch) => {
        const url = `https://tankimods.net${urls.commentDetails}${commentId}&delete=true` // urls.commentDetails.replace(/:(modVersionId)/g, modVersionId)

        const fetchPromise = fetch(url, { method: 'DELETE' }).promise
            .then((rawResponseData) => {
                dispatch(fetchEditComments(modId, type))
            }, () => {
                dispatch(showDialogError())
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}